import { type IconConfig, useIntl, useSettings } from '@capsicum/common';

export type NCWalletButtonsAction = 'history' | 'receive' | 'send' | 'stake' | 'topup';
type NCWalletButtonsIcons = 'HistoryIcon' | 'PlusIcon' | 'ReceiveArrowIcon' | 'StakeIcon' | 'WithdrawArrowIcon';
type NCWalletButtonsState = 'disabled' | 'enabled' | 'pending';

export type NCWalletButtonProp<IconComponent> = {
	bottomText: string;
	icon: IconConfig<IconComponent>;
	state: NCWalletButtonsState;
	testID: string;
	to: NCWalletButtonsAction;
};

export const useNCWalletActionBar = <IconComponent>({ ...icons }: Record<NCWalletButtonsIcons, IconComponent>) => {
	const { $t } = useIntl();
	const {
		settings: { isPoblanoEnabled, isTopupEnabled }
	} = useSettings();

	const buttonTexts = {
		history: $t('ncWallet.home.history'),
		receive: $t('ncWallet.home.receive'),
		send: $t('ncWallet.home.send'),
		stake: $t('ncWallet.home.stake'),
		topup: $t('ncWallet.home.topup')
	};

	const ncWalletButtonProps: Array<NCWalletButtonProp<IconComponent>> = [
		{
			bottomText: buttonTexts.topup,
			icon: { src: icons.PlusIcon },
			state: isTopupEnabled ? 'enabled' : 'disabled',
			testID: 'ncwHome-actionBar-topup-button',
			to: 'topup'
		},
		{
			bottomText: buttonTexts.history,
			icon: { src: icons.HistoryIcon },
			state: 'enabled',
			testID: 'ncwHome-actionBar-history-button',
			to: 'history'
		},
		{
			bottomText: buttonTexts.send,
			icon: { src: icons.WithdrawArrowIcon },
			state: 'enabled',
			testID: 'ncwHome-actionBar-send-button',
			to: 'send'
		},
		{
			bottomText: buttonTexts.receive,
			icon: { src: icons.ReceiveArrowIcon },
			state: 'enabled',
			testID: 'ncwHome-actionBar-receive-button',
			to: 'receive'
		},
		{
			bottomText: buttonTexts.stake,
			icon: { src: icons.StakeIcon },
			state: isPoblanoEnabled ? 'enabled' : 'disabled',
			testID: 'ncwHome-actionBar-stake-button',
			to: 'stake'
		}
	];

	return {
		ncWalletButtonProps
	};
};
